import React, { useCallback } from 'react';
import {
  Button,
  Space,
  Spin,
} from 'antd';
import { Form as HTMLForm, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { UserInformation } from './user-information';
import { IncidentInformation } from './incident-information';
import { Result } from './result';
import { Steps } from './steps';
import styles from './styles.module.less';

export function FormLayout({ step, setStep }) {
  const { t } = useTranslation();
  const {
    validateForm,
    setTouched,
    resetForm,
    isSubmitting,
  } = useFormikContext();

  const handleNext = useCallback(async () => {
    const result = await validateForm();
    if (step === 0) {
      if (result.name || result.surname || result.department) {
        setTouched({
          name: true,
          surname: true,
          department: true
        });
      } else {
        setStep((prev) => prev + 1);
      }
    }
  }, []);

  const handleBack = useCallback(() => {
    setStep((prev) => (prev === 0 ? 0 : prev - 1));
  }, []);

  const handleSubmitAgain = useCallback(() => {
    resetForm();
    setStep(0);
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.step}>
        <Steps current={step} />
      </div>
      <HTMLForm className={styles.form}>
        {step !== 2
          ? (
            <React.Fragment>
              <div className={styles.heading}>
                <h1 className={styles.title}>
                  {t('form.title')}
                </h1>
                <p className={styles.subtitle}>
                  {t('form.subtitle')}
                </p>
              </div>
              <Space
                size={32}
                direction="vertical"
                className={styles.space}
              >
                <Space
                  size={16}
                  direction="vertical"
                  className={styles.space}
                >
                  <Space
                    size={8}
                    direction="vertical"
                    className={styles.space}
                  >
                    {step === 0 && (
                      <UserInformation />
                    )}
                    {step === 1 && (
                      <IncidentInformation />
                    )}
                  </Space>
                  <div className={styles.buttons}>
                    {step === 0 && (
                      <Button
                        type="primary"
                        className={styles.button}
                        onClick={handleNext}
                      >
                        {t('button.next')}
                      </Button>
                    )}
                    {step === 1 && (
                      <Button
                        type="primary"
                        className={styles.button}
                        htmlType="submit"
                        loading={isSubmitting}
                        disabled={isSubmitting}
                      >
                        {t('button.submit')}
                      </Button>
                    )}
                    {step === 1 && !isSubmitting && (
                      <Button
                        className={styles.button}
                        onClick={handleBack}
                      >
                        {t('button.back')}
                      </Button>
                    )}
                  </div>
                </Space>
              </Space>
            </React.Fragment>
          )
          : (
            <Result onSubmitAgain={handleSubmitAgain} />
          )}
        {
          isSubmitting && (
            <div className={styles.spin}>
              <Spin />
            </div>
          )
        }
      </HTMLForm>
    </div>
  );
}
